import { useMutation } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/**
 * Mints a card-only SetupIntent via
 * `POST /api/portal/billing/setup-intents`. The response pairs the
 * client secret with the minting region so the browser can pick the
 * matching publishable key when confirming.
 */
export function useCreateSetupIntent() {
  const api = usePortalApi()
  return useMutation({
    mutationFn: async () => dataOrThrow(await api.post('/billing/setup-intents')),
  })
}
